import { resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock(_Fragment, null, [$setup.showHeader ? _withDirectives((_openBlock(), _createBlock(_component_Header, {
    key: 0
  }, null, 512)), [[_vShow, $setup.ifHeader]]) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createVNode(_component_router_view)])], 64);
}